import { useState, useEffect } from 'react';

export const useResponsive = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;

            if (width < 768) {
                setIsMobile(true);
                setIsTablet(false);
                setIsDesktop(false);
            } else if (width >= 768 && width < 1024) {
                setIsMobile(false);
                setIsTablet(true);
                setIsDesktop(false);
            } else {
                setIsMobile(false);
                setIsTablet(false);
                setIsDesktop(true);
            }
        };

        // Check on mount
        checkScreenSize();

        // Add event listener
        window.addEventListener('resize', checkScreenSize);

        // Cleanup
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    return {
        isMobile,
        isTablet,
        isDesktop,
        screenSize: isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop'
    };
};